document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".variant__button-label").forEach(label => {
        label.addEventListener("click", function() {
            const forAttribute = this.getAttribute("for");
            if (!forAttribute) return;

            let input;
            // Essayer d'abord de trouver l'input directement par son ID brut
            input = document.getElementById(forAttribute);
            if (!input) {
                // Si ça échoue, chercher parmi les inputs avec le même name
                const tempInput = document.querySelector('input[name="' + this.name + '"]');
                if (tempInput) {
                    const variantInputs = document.querySelectorAll('input[name="' + tempInput.name + '"]');
                    input = Array.from(variantInputs).find(inp => inp.id === forAttribute);
                }
            }
            if (!input) {
                console.error("Input non trouvé pour :", forAttribute);
                return;
            }

            // Trouver le slider le plus proche
            const productContainer = this.closest(".product-container") || document.body;
            const slider = productContainer.querySelector(".slick-slider");
            if (!slider) {
                console.error("Slider non trouvé pour ce produit");
                return;
            }

            // Récupérer les variantes dynamiquement
            const variantInputs = document.querySelectorAll('input[name="' + input.name + '"]');
            const variantValues = Array.from(variantInputs).map(input => input.value);
            const selectedValue = input.value;
            const slideIndex = variantValues.indexOf(selectedValue);

            if (slideIndex === -1) {
                console.error("Variante non trouvée :", selectedValue);
                return;
            }

            // Aller au slide correspondant
            $(slider).slick("slickGoTo", slideIndex, true);
            console.log("⚡️ Slide instantané :", slideIndex);

            // Forcer le recalcul
            $(slider).slick("setPosition");
        });
    });
});